"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getLocale", {
  enumerable: true,
  get: function get() {
    return _i18n.getLocale;
  }
});
var _i18n = require("./i18n");